module.exports = __webpack_public_path__ + "static/img/celoscope-18.fdc915f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-18.jpg
// module id = zE1l
// module chunks = 52